<template>
  <div class="content-wrap">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <bk-tab
      class="content_tab"
      v-model="defaultTabIndex"
      :tab-items="tabList"
      @on-change="onTabChange"
    ></bk-tab>
  </div>
</template>

<script>
import bkTab from "@/components/bk-tab.vue";
export default {
  name: "",
  components: { bkTab },
  props: {},
  data() {
    return {
      defaultTabIndex: 0,
      tabList: [
        {
          value: "小区列表",
          url: "/miniCommunity"
        },
        {
          value: "小区展示",
          url: "/miniCommunity/gallery"
        }
      ]
    };
  },
  watch: {},
  computed: {},
  methods: {
    onTabChange(index) {
      sessionStorage.miniCommunityTabIndex = index;
      let cur = this.tabList[index];
      this.$router.replace({
        path: cur.url
      });
    }
  },
  created() {},
  mounted() {
    this.defaultTabIndex = Number(sessionStorage.miniCommunityTabIndex) || 0;
  },
  beforeDestroy() {
    sessionStorage.removeItem("miniCommunityTabIndex");
  },
  beforeRouteLeave(to, from, next) {
    // 如果路由路径不在 miniCommunity 置空updateMiniCommunityChangeId缓存
    if (!/^\/miniCommunity/.test(to.fullPath)) {
      this.$store.commit("updateMiniCommunityChangeId", "");
    }
    next();
  }
};
</script>
<style lang="less" scoped>
.content_tab {
  position: absolute;
  top: 30px;
  left: 20px;
}
</style>
